import { useMediaPreview } from "./MediaPreviewProvider";
import style from "./PreviewAvatarMedia.module.scss";
import Spinner from "../Spinner/Spinner";

interface Props {
    handlePreviewAvatar: () => void;
}

const PreviewAvatarMedia: React.FC<Props> = ({ handlePreviewAvatar }) => {
    const { isLoadingMedia, videoUrl, videoRef, imageUrl, currentTab, setVideoState } = useMediaPreview();

    const isAvatarTab = currentTab === "appearance";
    const isSceneTab = currentTab === "scene";

    if (isLoadingMedia) {
        return (
            <div className={style.spinnerWrapper}>
                <Spinner size={"medium"} />
            </div>
        );
    }

    return (
        <div className={style.avatarVideoContainer}>
            <button
                className={style.deployButton}
                onClick={handlePreviewAvatar}
            >
                Посмотреть аватара
            </button>
                {isAvatarTab && videoUrl && (
                    <video
                        key={videoUrl}
                        ref={videoRef}
                        playsInline
                        preload="auto"
                        className={style.video}
                        onEnded={() => setVideoState("not active")}
                    >
                        <source src={videoUrl} type="video/mp4" />
                    </video>
                )}

                {isSceneTab && imageUrl && (
                    <img key={imageUrl} src={imageUrl} alt="avatar in scene" loading="lazy" />
                )}

                {isAvatarTab && !videoUrl && (
                    <p key="no-video" className={style.previewUnavailable}>
                        Превью голоса недоступно
                    </p>
                )}

                {isSceneTab && !imageUrl && (
                    <p key="no-image" className={style.previewUnavailable} >
                        Превью сцены недоступно
                    </p>
                )}
        </div>
    );
};

export default PreviewAvatarMedia;
